<template>
  <section class="section__about">
    <!-- Floating case study on right top -->
    <!-- <FloatingCaseStudy :caseText="caseText"></FloatingCaseStudy> -->

    <!-- All animating objects -->
    <div class="section__about--bg"></div>
    <div class="section__about--box">
      <div class="section__about--counters">
        <div class="counter-box">
          <div class="counter-box__block">
            <h2>{{ animatedNumber }}+</h2>
            <!-- <input v-model="number"> -->
            <span>happy clients</span>
          </div>
          <div class="counter-box__block">
            <h2>{{ animatedNumber2 }}+</h2>
            <span>people</span>
          </div>
          <div class="counter-box__block">
            <h2>{{ animatedNumber3 }}+</h2>
            <span>projects</span>
          </div>
          <div class="counter-box__block">
            <h2>{{ animatedNumber4 }}</h2>
            <span>hours spent on projects</span>
          </div>
        </div>
      </div>
      <div class="section__about--content">
        <div class="about-nav__title">
          <h2>LET’S WORK TOGETHER</h2>
        </div>

        <div class="about-nav__box">
          <div class="about-nav__box--list">
            <AboutTabs />
          </div>
        </div>
      </div>

      <FloatingContact
        :floatingContactColor="floatingContactColor"
        :floatingContactLetterColor="floatingContactLetterColor"
      />
    </div>
  </section>
</template>

<script>
import SectionTitle from "@/components/small-components/SectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";
import FloatingCaseStudy from "@/components/small-components/FloatingCaseStudy";
import FloatingContact from "@/components/small-components/FloatingContact";
import AboutTabs from "@/components/small-components/AboutTabs";

export default {
  name: "ComponentAbout",
  data() {
    return {
      selected: undefined,
      caseText: "About.",
      floatingContactColor: "#cacaca",
      floatingContactLetterColor: "#000",
      newValue: 0,
      interval: false,
      thisSection: 10,
      tweenedNumber: 0,
      tweenedNumber2: 0,
      tweenedNumber3: 0,
      tweenedNumber4: 0
    };
  },
  props: ["activeSection", "activeSectionSubpage"],
  computed: {
    animatedNumber: function() {
      return this.tweenedNumber.toFixed(0);
    },
    animatedNumber2: function() {
      return this.tweenedNumber2.toFixed(0);
    },
    animatedNumber3: function() {
      return this.tweenedNumber3.toFixed(0);
    },
    animatedNumber4: function() {
      return this.tweenedNumber4.toFixed(0);
    }
  },
  watch: {
    activeSection: function() {
      if (this.activeSection == this.thisSection) {
        this.number = "99999";
        this.newValue = "100";
        this.newValue2 = "20";
        this.newValue3 = "130";
        this.newValue4 = "23432";
        TweenLite.to(this.$data, 3.5, {
          ease: Power4.easeOut,
          tweenedNumber: this.newValue,
          tweenedNumber2: this.newValue2,
          tweenedNumber3: this.newValue3,
          tweenedNumber4: this.newValue4
        });
      }
      clearInterval(this.interval);

      this.interval = window.setInterval(
        function() {
          if (this.displayNumber != this.number) {
            var change = (this.number - this.displayNumber) / 10;

            change = change >= 0 ? Math.ceil(change) : Math.floor(change);

            this.displayNumber = this.displayNumber + change;
          }
        }.bind(this),
        20
      );
    }
  },
  mounted: function() {},
  created() {
    this.checkSubpage();
  },
  methods: {
    handleTabChange(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab.title, oldTab.title);
    },
    checkSubpage() {
      if (this.activeSectionSubpage == true) {
        this.number = "99999";
        this.newValue = "100";
        this.newValue2 = "20";
        this.newValue3 = "130";
        this.newValue4 = "23432";
        TweenLite.to(this.$data, 3.5, {
          ease: Power4.easeOut,
          tweenedNumber: this.newValue,
          tweenedNumber2: this.newValue2,
          tweenedNumber3: this.newValue3,
          tweenedNumber4: this.newValue4
        });
      }
    }
  },

  // Init components
  components: {
    SectionTitle: SectionTitle,
    FloatingSocials: FloatingSocials,
    FloatingCaseStudy: FloatingCaseStudy,
    FloatingContact: FloatingContact,
    AboutTabs
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentAbout.vue